/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TEXT from "../../../utils/globalText";
// Component
import ICONS from "../../../assets/Icons";
import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { reimbursementTxnRequestSuccessDetail } from "../../../redux/features/reimbursementTransaction";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import useCategories from "../../../utils/useCategories";

const ReimbursementSuccessPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    reimbursementTxnSuccessRequestData,
    reimbursementTxnSuccessRequestLoading,
    reimbursementTxnSuccessRequestDataError,
  } = useSelector((state) => state.reimbursementTransaction);

  const categoryMapper = useCategories();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);
  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, []);
  useEffect(() => {
    if (
      reimbursementTxnSuccessRequestDataError ===
      "Request failed with status code 404"
    ) {
      navigate(
        `/reimbursement_transaction_dashboard/create_reimbursement_transactions/failed`,
      );
    }
  }, [reimbursementTxnSuccessRequestDataError]);

  useEffect(() => {
    dispatch(reimbursementTxnRequestSuccessDetail(id));
  }, [id]);

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };

  const beneAccount = () => {
    const beneId =
      reimbursementTxnSuccessRequestData?.request[0]?.beneficiary_account_id;

    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${beneId}`,
      {
        replace: true,
      },
    );
  };

  const createAccountHandler = () => {
    navigate(
      "/reimbursement_transaction_dashboard/create_reimbursement_request",
      {
        replace: true,
      },
    );
  };

  const dashboardHandler = () => {
    navigate("/reimbursement_transaction_dashboard", {
      replace: true,
    });
  };

  // Button

  const buttonRows = [
    [
      {
        btnText: "Create request",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];
  const categoryIcon = categoryMapper(
    reimbursementTxnSuccessRequestData?.request[0]?.category_id?.category_id,
  );
  return (
    <>
      <StatusContainer
        isLoading={reimbursementTxnSuccessRequestLoading}
        status="success"
        hoverOption="black"
        title={"Request created successfully."}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Request details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          reimbursementTxnSuccessRequestData?.request[0]
                            ?.requested_amount ??
                          GlobalConfiguration.lengthCheckZero
                        }
                      />
                    </>
                  ),
                  leftSubTitle: "Requested amount",
                  leftTextFontWeight: "semibold",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.beneficiary_account_name,
                  leftTitleTextFontSize: "font-md",
                  leftSubTitle: "Account name",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={beneAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.beneficiary_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.ACCOUNT_NUMBER,
                  ifsc: reimbursementTxnSuccessRequestData?.request[0]
                    ?.beneficiary_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    reimbursementTxnSuccessRequestData?.request[0]?.category_id
                      ?.category_name,
                  leftSubTitle: "Category",
                  icon: categoryIcon.url,
                  iconColor: categoryIcon.colour,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: id,
                  leftSubTitle: "Request ID",
                  copyText: id,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default ReimbursementSuccessPage;
